module.exports = __webpack_public_path__ + "img/logo.3702d1f4.png";